import { useEffect, useRef } from 'react';
import { useLocale } from 'next-intl';

//* Helpers
import { config } from '@/helpers';

//* Styles
import FAQSectionStyle from './style';

//* Components
import Icon from '@/components/Icon';
import Text from '@/components/Text';
import Button from '@/components/Button';
import Container from '@/components/Container';
import useTrigger from '@/components/Animation/useTrigger';
import { CollapseContainer, CollapseItem } from '@/components/Collapse';
import TextAnimation from '@/components/Animation/TextAnimation/TextAnimation';

//* Data
import { dataFAQ } from '@/data';

const FAQSection = () => {
	const lang = useLocale();

	//! Ref
	const styleRef = useRef();
	const titleRef = useRef();

	useEffect(() => {
		const trigger = useTrigger({
			ref: styleRef.current,
			documentPercent: 70,

			onEnter: () => {
				styleRef.current.classList.add('active');
				titleRef.current.children[0].classList.add('active');
			},
		});
		return () => {
			trigger();
		};
	}, []);

	return (
		<FAQSectionStyle ref={styleRef}>
			<Container
				row
				isSection>
				<div className='left-block col-6 col-m-12'>
					<div className='left-inner-block'>
						<Text
							ref={titleRef}
							tag={'h2'}
							className={'h3 font-montserrat-arm-medium uppercase'}>
							<TextAnimation
								delay={0.2}
								text={dataFAQ[lang].title}
							/>
						</Text>

						<div className='description-block'>
							<Text className={'p2 description1'}>{dataFAQ[lang].description1}</Text>

							<Text className={'p2 description2'}>{dataFAQ[lang].description2}</Text>
						</div>

						<Button
							url={config.routes.contactUs.path}
							text={config.routes.contactUs.name}
						/>
					</div>
				</div>

				<div className='right-block col-6 col-m-12'>
					<div className='right-inner-block'>
						<CollapseContainer>
							{dataFAQ[lang].items.map((item, index) => {
								return (
									<div
										style={{ '--itemDelay': index }}
										className='outside-wrap-collapse-item'
										key={index}>
										<CollapseItem
											title={
												<div className='title-block'>
													<Text className={'p p2 font-montserrat-arm-medium uppercase item-title'}>{item.title}</Text>

													<Icon name={'arrowRight'} />
												</div>
											}
											description={<Text className={'p p4 item-description'}>{item.description}</Text>}
										/>
									</div>
								);
							})}
						</CollapseContainer>
					</div>
				</div>
			</Container>
		</FAQSectionStyle>
	);
};

export default FAQSection;
